"use client";

import { Box, Divider, Grid } from "@mui/material";
import { useState } from "react";
import { OccupancyChart } from "../charts/occupyency-chart";
import { RentalIncomeChart } from "../charts/rental-income-chart";
import PropertyDashboardGlanceView from "../property-dashboard-glance";
import StatCardWrapper from "../stat-card/statCardWrapper";
import { useGetDashboardDataQuery } from "../../redux/api/dashboard";
import LoaderFullScreen from "../common/LoaderFull";

export default function DashboardWrapper() {
  const { data: dashboardData, isLoading } = useGetDashboardDataQuery()
  const [tab, setTab] = useState(0);

  return (
    <>
      {isLoading && (
        <LoaderFullScreen />
      )}

      <Box mt={{ xs: 0, md: 4, sm: 2 }} width="100%" maxWidth="100%">
        <StatCardWrapper data={dashboardData?.data} loading={isLoading} />

        <Divider />

        {/* <Grid container spacing={3} mt={{ xs: 4, sm: 5, md: 10 }} mb={{ xs: 4, sm: 5, md: 10 }} >
          <Grid size={{ xs: 12, sm: 12, md: 8 }}>
            <RentalIncomeChart />
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 4 }}>
            <OccupancyChart />
          </Grid>
        </Grid> */}
        {/* <PropertyDashboardGlanceView /> */}

      </Box>
    </>
  );
}
